var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"filters"},_vm._l((_vm.filters),function(type,index){return _c('a',{key:index,staticClass:"btn filters-btn mr-2 mt-2",class:{
      'filters-btn_active': _vm.activeFilter === type,
      'filters-btn_disabled': _vm.disabled
    },on:{"click":function($event){!_vm.disabled && _vm.$emit('filter-change', type)}}},[_vm._v("\n    "+_vm._s(_vm.getFilterButtonTitle(type))+"\n  ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }